var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareSuccessImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.9765 47.7848C52.8026 39.6958 55.9011 23.4552 47.9106 11.4969C39.9111 -0.461403 23.8501 -3.59462 12.024 4.48531C0.197997 12.5742 -2.90057 28.8149 5.09 40.7732C13.0894 52.7315 29.1505 55.8647 40.9765 47.7848Z",
    fill: "#4CAF50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 31.66L21.5629 39L40 12",
    stroke: "#EDF7EE",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareSuccessImg);
export default __webpack_public_path__ + "static/media/share-success-img.c1625e2e32d1018f824b622a6bf26150.svg";
export { ForwardRef as ReactComponent };